import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../Display/Icon/Icon';

const Display = ({
  afterLabelContent = null,
  disabled,
  id,
  label,
  onEditClick,
  value,
  hideLabel = false,
  preValueText = '',
}) => {
  return (
    <div className="flex">
      <div className="w-full pr-2.5">
        <h5
          className={
            hideLabel
              ? 'sr-only'
              : 'capitalize font-semibold text-text-blue text-sm font-heavy-font tracking-normal leading-4'
          }
        >
          {label}
        </h5>
        <div>
          {afterLabelContent}
        </div>
        <span className="text-sm text-brand-blue">
          {preValueText}
          {value}
        </span>
      </div>
      {!disabled && (
        <div>
          <Icon
            icon="Edit"
            onClick={onEditClick}
            id={`${id}-edit-btn`}
            color="#4467AB"
            ariaLabel="Edit"
            size={18}
          />
        </div>
      )}
    </div>
  );
};

Display.propTypes = {
  afterLabelContent: PropTypes.node,
  disabled: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.any.isRequired,
  onEditClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  preValueText: PropTypes.node,
};

export default Display;
